import React from 'react';

class NodeWithoutChildren extends React.Component {
  render() {
    return <img className="node-without-children" src="/images/hnav/dot.png" />;
  }
}

export default NodeWithoutChildren;
